module.exports = __webpack_public_path__ + "static/media/iaml_cortesia.99e8f1f3.png";